import { PureComponent, ComponentType } from 'react';
import cx from 'classnames';

import WithFormulaData from '../../../decorators/WithFormulaData';
import { parseQuery } from '../../../utils/utils';

import ExpressionSelector from '../../../expressions/ExpressionSelector/ExpressionSelector';
import TextField from '../../../components/TextField/TextField';
import type { Dispatch } from 'redux';
import type { UiFormulaNode } from '../../../typeDefs';

const DEBUG = parseQuery().debug != null;

interface BuilderFunctionProps {
    path: string;
    data: UiFormulaNode & { id?: string; name?: string };
    onClone: () => void;
    onRemove: () => void;
    dispatch?: Dispatch;
    className?: string;
    [key: string]: unknown;
}

class BuilderFunction extends PureComponent<BuilderFunctionProps> {
    handleNameChange = (name: string) => this.props.data.change('name', name);

    handleDescriptionChange = (description: string) => this.props.data.change('description', description);

    handleRemove = () => {
        if (!window.confirm(`You are about to remove: ${this.props.data.name}`)) return;
        this.props.onRemove();
    };

    render() {
        const { data, path, onClone, onRemove, dispatch, className, ...rest } = this.props;

        return (
            <div {...(rest as React.HTMLAttributes<HTMLDivElement>)} className={cx('BuilderFunction-root', className)}>
                <div className={'BuilderFunction-remove'} onClick={this.handleRemove}>×</div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {!DEBUG ? null :
                        <div className={'BuilderFunction-debug'}>{data.id}</div>
                    }
                    <TextField style={{ flex: '1 1 0' }} inputClassName='BuilderFunction-TextField' defaultValue={data.name} onChange={this.handleNameChange} />
                </div>
                <button className={'BuilderFunction-clone'} onClick={onClone}>clone</button>
                <ExpressionSelector
                    depth={0}
                    path={data.getChildPath('structure')}
                    noRemove={true}
                    className={'BuilderFunction-expression'}
                />
            </div>
        );
    }
}

export default WithFormulaData(BuilderFunction as ComponentType<any>) as unknown as ComponentType<any>;
